export const reply = [
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 Claimant Skeleton BL-2021-BRS-000008-01.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 Claimant Skeleton BL-2021-BRS-000008-02.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 Claimant Skeleton BL-2021-BRS-000008-03.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 Claimant Skeleton BL-2021-BRS-000008-04.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 Claimant Skeleton BL-2021-BRS-000008-05.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 Claimant Skeleton BL-2021-BRS-000008-06.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 Claimant Skeleton BL-2021-BRS-000008-07.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 Claimant Skeleton BL-2021-BRS-000008-08.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 Claimant Skeleton BL-2021-BRS-000008-09.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 Claimant Skeleton BL-2021-BRS-000008-10.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_09_25 BL-2021-BRS-000008 Letter on Directions Questionnaire and CPR 19-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_02 REPLY BL-2021-BRS-000008-1.jpg"
  }
];
